// Auto-generated preview thumbnails for custom frames. A frame is a clip path
// in its own viewBox, so a filled silhouette is the natural preview. Returns an
// inline SVG string (and a data-URL form) — no canvas needed, crisp at any size.

export function frameThumbnailSvg(path, vbW = 1, vbH = 1, opts = {}) {
  const fill = opts.fill || '#c7d2fe';
  const stroke = opts.stroke || '#6366f1';
  const sw = Math.max(vbW, vbH) * 0.012;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${vbW} ${vbH}" preserveAspectRatio="xMidYMid meet">`
    + `<path d="${path}" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/></svg>`;
}

export function frameThumbnailDataUrl(path, vbW = 1, vbH = 1, opts = {}) {
  return `data:image/svg+xml;utf8,${encodeURIComponent(frameThumbnailSvg(path, vbW, vbH, opts))}`;
}
